import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { Rate as AntRate } from 'antd';
import { RateProps } from 'antd/es/rate';
import { FC } from 'react';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';

const CustomRate = styled(AntRate)<RateProps>`
  & {
    color: var(--yellow-50);
  }

  ${ifProp(
    'disabled',
    css`
      .ant-rate-star:not(:last-child) {
        margin-right: var(--spacing-02);
      }
    `,
  )};
`;

export const Rate: FC<React.PropsWithChildren<RateProps>> = (props) => (
  <CustomRate
    character={<FontAwesomeIcon icon={faStar} />}
    allowHalf
    {...props}
  />
);
